import type { NewUserQuizCopy } from '../types';

export const DE_NEW_USER_QUIZ_COPY = {
  booking: {
    backToVideo: 'Zurück zu deinem Video',
    bookedSnackbar: 'Deine Demo ist gebucht – bis bald!',
    bullets: {
      pricing: 'Klare Preise nach Volumen und Support-Level',
      teams: 'Für Teams gemacht: Reviewer, Glossare, eine gemeinsame Bibliothek',
      setup: 'Finde das passende Setup für deine Inhalte und deinen Workflow',
    },
    confirmation: {
      title: 'Deine Demo ist gebucht',
      description:
        'Eine Kalendereinladung wurde an deine E-Mail-Adresse gesendet. Deine lokalisierte Vorschau bleibt vor dem Gespräch verfügbar und teilbar.',
    },
    continue: 'Weiter',
    decision: {
      bookDemo: {
        title: 'Demo buchen',
        buttonLabel: 'Demo buchen',
        description:
          'Gehe mit einem Spezialisten Team-Workspaces, API und Synchronisation in großem Umfang durch – und finde heraus, wie Rask in deinen Workflow passt.',
      },
      exploreEditor: {
        title: 'Im Editor weiterarbeiten',
        buttonLabel: 'Editor öffnen',
        description: 'Verfeinere Skript, Stimmen und Timing selbst. Während deiner Testphase ist alles freigeschaltet.',
      },
    },
    description: 'Wir richten Rask passend zu deinen Inhalten, deinem Team und deinem Volumen ein.',
    followUp: {
      callAgenda: [
        'Ein kurzer Blick auf deine erstellte Vorschau',
        'Dein Workflow, Volumen und Rollout-Plan',
        'Wir richten den Editor auf deinen Workflow ein',
      ],
      callDescription: 'Bestätigtes Datum, Uhrzeit und Teilnahmelink findest du in deiner Kalendereinladung.',
      callDurationLabel: (minutes) => `${minutes}-minütiger Videoanruf`,
      callTitle: 'Dein Gespräch',
      manageBooking: {
        title: 'Buchung verwalten',
        buttonLabel: 'Buchung verwalten',
        closeLabel: 'Schließen',
        description:
          'Um das Gespräch zu verschieben oder abzusagen, öffne den Termin in deinem Firmenkalender und nutze die Optionen in der Einladung.',
        googleCalendarLabel: 'Google-Firmenkalender öffnen',
        outlookCalendarLabel: 'Outlook-Firmenkalender öffnen',
      },
      prepareDescription:
        'Lade Teammitglieder ein und notiere Änderungen an Text, Stimme oder Timing, die du besprechen möchtest.',
      prepareTitle: 'Bereite dich auf das Gespräch vor',
      share: {
        title: 'Teile diese Vorschau mit deinem Team',
        buttonLabel: 'Teilen',
        copiedButtonLabel: 'Kopiert!',
        copyButtonLabel: 'Kopieren',
        description:
          'Sende die lokalisierte Vorschau an dein Team, damit alle mit hilfreichem Feedback ins Gespräch kommen.',
        modalDescription: 'Sende dein Video über den folgenden Link an andere',
        modalTitle: 'Video teilen',
      },
      videoCallLabel: 'Videoanruf',
    },
    heading: 'Buche dein Setup-Gespräch',
    headingSecondLine: '',
    maybeLater: 'Vielleicht später',
    persistenceError: 'Dieser Schritt konnte nicht gespeichert werden. Wähle „Weiter“, um es erneut zu versuchen.',
    rating: '4,7/5 auf G2',
    scheduler: {
      fallbackBookedLabel: 'Ich habe einen Termin gebucht',
      openBookingPage: 'Buchungsseite öffnen',
      loadErrorDescription:
        'Dein Netzwerk oder deine Region blockiert möglicherweise die Einbettung. Öffne stattdessen die Buchungsseite in einem neuen Tab.',
      loadErrorTitle: 'Der Terminplaner konnte nicht geladen werden',
      loadingLabel: 'Terminplaner wird geladen',
    },
    trustedBy: 'Weltweit von Teams geschätzt',
    verificationPending: {
      title: 'Deine Buchung wird bestätigt',
      description: 'Wir prüfen die Termindetails mit HubSpot. Das kann einen Moment dauern.',
    },
  },
  controls: {
    back: 'Zurück',
    continue: 'Weiter',
    continueAnyway: 'Trotzdem fortfahren',
    progress: (currentStep, totalSteps) => `Frage ${currentStep} von ${totalSteps}`,
    submitError: 'Deine Antworten konnten nicht gespeichert werden. Bitte versuche es erneut.',
  },
  priorityQuestion: {
    title: 'Was hat für dich bei der Lokalisierung gerade Priorität?',
    audioTitle: 'Was hat für dich bei der Lokalisierung gerade Priorität?',
    options: {
      collaborate_with_team_or_reviewers: { label: 'Qualitätskontrolle und Workflow' },
      consistent_voice_and_terminology: { label: 'Einheitliche Stimme und Terminologie' },
      fast_results_no_setup: { label: 'Einfache und schnelle Einzelarbeit' },
      integration_into_product_or_workflow: { label: 'Integration und Compliance' },
      not_sure_yet: { label: 'Noch nicht sicher' },
    },
    subtitle: 'Wähle eine Option',
  },
  questions: {
    content_team_size: {
      title: 'Wie viele Personen in deinem Team arbeiten mit Videoinhalten?',
      options: {
        just_me: { label: '1' },
        large_team_5_plus: { label: '8+' },
        small_team_2_5: { label: '2-7' },
      },
    },
    localization_frequency: {
      title: 'Wie oft lokalisierst du Videos?',
      audioTitle: 'Wie oft lokalisierst du Inhalte?',
      options: {
        continuously: { label: 'Ich habe einen kontinuierlichen Bedarf' },
        occasionally_quarterly: { label: 'Gelegentlich' },
        regularly_monthly: { label: 'Regelmäßig', description: 'Jeden Monat' },
        one_time_project: { label: 'Ich habe eine einmalige Aufgabe' },
      },
    },
  },
} satisfies NewUserQuizCopy;
